module.exports = __webpack_public_path__ + "static/media/arrow-right-bt.92ec56cb.svg";